import React from 'react';

import lang from '../../lib/language';

import experienceIllustrationEffectImage from '../../assets/bigImages/experience_illustration_effects2.png';
import { EnrollBgText } from '../../containers/Enroll/Enroll.constants';
import { useIsMobile } from '../../hooks';

import styles from './TransitionScreen.module.scss';

type Props = {}

const TransitionScreen = (props: Props) => {
  const isMobile = useIsMobile();

  const contentHtml = (
    <>
      <div className={styles.imageWrapper}>
        <img
          src={experienceIllustrationEffectImage}
          className={styles.image}
          alt=""
        />
      </div>
      <div className={styles.textsWrapper}>
        <p className={styles.caption}>
          {EnrollBgText.title}
        </p>
        {isMobile && (
        <>
          <p className={styles.description}>
            {EnrollBgText.desc1}
          </p>
          <p className={styles.description}>
            {EnrollBgText.desc2}
          </p>
        </>
        )}
        {!isMobile && (
          <>
            <p className={styles.description}>
              {EnrollBgText.desc1}
            </p>
            <p className={styles.description}>
              {EnrollBgText.desc2}
            </p>
          </>
        )}
      </div>
    </>
  );

  if (isMobile) {
    return (
      <div className={styles.screen}>
        {contentHtml}
      </div>
    );
  }

  return contentHtml;
};

export default TransitionScreen;
